import { Constants } from './Constants';

export class WaterProductUtil {
	public static isWaterProduct(productType?: string | undefined) {
		return productType ? productType === Constants.PRODUCT_TYPE_WATER : false;
	}
}
